<div class="modal-header border-bottom-0 pb-4">
  <h5 class="modal-title">{{ 'api.error.default' | translate }}</h5>
  <button (click)="activeModal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
